import { Text } from '@ui-component-library';
import { usePlusBlockerDialog } from '@components/PlusBlockerDialog/PlusBlockerDialog.context';

type PlusCoverProps = {
    children: React.ReactNode;
    hasPlus: boolean;
};

export function PlusCover({ children, hasPlus }: PlusCoverProps) {
    const { openPlusBlockerDialog } = usePlusBlockerDialog();

    if (hasPlus) {
        return <>{children}</>;
    } else {
        return (
            <div className="relative w-full cursor-pointer" onClick={() => { openPlusBlockerDialog('section-details') }}>
                <div className="blur-sm">
                    {children}
                </div>
                <div className="flex items-center rounded absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#F6F5FE] px-1 py-0-5">
                    <img src={`${Window.static_path || '/'}img/icons/sparkle.svg`} height='12px' width='12px' />
                    <Text className="text-[#6856C3]" variant="text-xs/leading-normal/medium">Plus</Text>
                </div>
            </div>
        );
    }
}

type PlusTabProps = {
    text: string;
};

export function PlusTab({ text }: PlusTabProps) {
    const { openPlusBlockerDialog } = usePlusBlockerDialog();

    return (
        <div className="m-2">
            <div className="flex flex-wrap w-full p-4 justify-center bg-cloud-200 rounded-lg border border-solid border-[#E6E6E6] cursor-pointer" onClick={() => { openPlusBlockerDialog('section-details') }}>
                <div className="flex items-center rounded bg-[#F6F5FE] px-1 py-0-5">
                    <img src={`${Window.static_path || '/'}img/icons/sparkle.svg`} height='24px' width='24px' />
                    <Text className="text-[#6856C3]" variant="text-sm/leading-normal/medium">Köp plus</Text>
                </div>
                <Text variant="text-sm/leading-normal/medium" className="py-2 pl-6 pr-2 text-center">{text}</Text>
            </div>
        </div>
    );
}
